import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Boost your online presence with our SEO services. We improve website visibility, attract targeted traffic, and build brand credibility through effective optimization strategies. Our team stays updated with the latest algorithms and best practices, optimizing your website for higher rankings in search engine results pages (SERPs). Drive organic traffic, increase market share, and achieve long-term success with our proven SEO techniques.",
    servicePointsLoop: [
      "Enhanced online visibility and search engine rankings.",
      "Targeted traffic generation for increased conversions.",
      "Establishing brand credibility and trust.",
      "Gaining a competitive edge in the digital landscape.",
    ],
    serviceDiv: [
      {
        heading: "Improved Online Visibility",
        description: "Improve website visibility and rankings in search engine results.",
      },
      {
        heading: "Targeted Traffic Generation",
        description:
          "Attract targeted traffic and increase online brand credibility.",
      },
      {
        heading: "Building Brand Credibility",
        description: "Implement effective optimization strategies for long-term marketing success.",
      },
      {
        heading: "Competitive Advantage",
        description:
          "Drive organic traffic, capture market share, and stay ahead of the competition.",
      },
    ],
  };
  let workWithUs =
    "Harness the power of SEO and partner with us to achieve higher website rankings, increased organic traffic, and sustainable online growth. Our expertise in optimization techniques and commitment to delivering measurable results make us the ideal choice for your SEO needs.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Search Engine Optimization (SEO)" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
